/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";

export const Footer = () => {
  const LinkedInIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );

  const YouTubeIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo-text">
              <img src="/images/healthlogo2.svg" alt="Logo" class="nav_logo" width="155" height="35" />
            </div>
            <p className="footer-tagline">
              Personalized MSK recovery.
              <br />
              Built for access. Designed for scale.
            </p>
          </div>
          <div className="footer-columns">
            <div className="footer-col">
              <p className="footer-col-title">Company</p>
              <Link to={`/about-us`}>About Us</Link>
              <Link to={`/contact-us`}>Contact Us</Link>
              <Link to="#">Press &amp; News</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <span>&copy; 2026 Virdio Health. All rights reserved.</span>
            <Link to="#">Privacy Policy</Link>
            <Link to="#">Terms of Service</Link>
            <Link to="#">HIPAA Notice</Link>
          </div>
          <div className="footer-bottom-right">
            <a href="https://www.linkedin.com/company/virdiohealth" target="_blank" rel="noopener noreferrer">
              <LinkedInIcon />
            </a>
            <a href="https://www.youtube.com/@VirdioHealth" target="_blank" rel="noopener noreferrer">
              <YouTubeIcon />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
